import { makeStyles } from '@material-ui/core/styles';

/**
 * Shared styles for Markdown rendering (tables, links, code blocks).
 * Used by StandardCompliance Markdown component to reduce duplication.
 */
export const useMarkdownStyles = makeStyles((theme) => ({
  markdownContent: {
    fontSize: '1.16em',
    lineHeight: 1.8,
    '& table': {
      borderCollapse: 'collapse',
      border: `1px solid ${theme.palette.divider}`,
    },
    '& th, & td': {
      border: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(1),
    },
    '& td': {
      wordBreak: 'break-word',
      overflow: 'hidden',
      verticalAlign: 'middle',
      lineHeight: '1',
      margin: 0,
      padding: theme.spacing(3, 2, 3, 2.5),
      borderBottom: 0,
    },
    '& th': {
      backgroundColor: theme.palette.background.paper,
    },
    '& tr': {
      backgroundColor: theme.palette.background.paper,
    },
    '& tr:nth-child(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    '& a': {
      color: theme.palette.primary.main,
    },
    '& img': {
      maxWidth: '100%',
    },
    '& code': {
      padding: theme.spacing(0, 0.25),
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.shape.borderRadius,
    },
  },
}));
